import React, { useEffect } from "react";
import { Route, Switch, withRouter, useLocation } from "react-router-dom";
import audit from "./Audit/Audit.jsx";
import locationChecker from "./SearchLocationChecker/SearchLocationCheck";
import home from "./Home/Home";
import advancedSearch from "./AdvancedSearch/AdvancedSearch.jsx";
import reviewCalculator from "./ReviewCalculator/ReviewCalculator.jsx";
import structuredData from "./StructuredData/StructuredData.jsx";
import auditStoreLocator from "./AuditStoreLocator/AuditStoreLocator.jsx";
import reviewSemanticAnalysis from "./ReviewSemanticAnalysis/ReviewSemanticAnalysis.jsx";
import gbpCategories from "./GbpCategories/GbpCategories.jsx";
import HeaderApp from "../components/Header/Header";
import "../components/ui/ui.scss";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <div className="App main">
      <ScrollToTop />
      <header className="app-header">
        <HeaderApp />
      </header>
      <main className="app-content">
        <Switch>
          <Route exact path="/" component={home} />
          <Route exact path="/audit-google-my-business" component={audit} />
          <Route exact path="/serp-local-google" component={locationChecker} />
          <Route
            exact
            path="/missing-reviews-calculator"
            component={reviewCalculator}
          />
          <Route
            exact
            path="/local-business-structured-data-generator"
            component={structuredData}
          />
          <Route
            exact
            path="/search-extraction-google"
            component={advancedSearch}
          />
          <Route
            exact
            path="/audit-store-locator"
            component={auditStoreLocator}
          />
          <Route
            exact
            path="/reviews-semantic-analysis"
            component={reviewSemanticAnalysis}
          />
          <Route
            exact
            path="/google-business-profile-categories"
            component={gbpCategories}
          />
        </Switch>
      </main>
    </div>
  );
};

export default withRouter(App);
